'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxImmutable = require('redux-immutable');

var _cart = require('./cart');

var _cart2 = _interopRequireDefault(_cart);

var _products = require('./products');

var _products2 = _interopRequireDefault(_products);

var _events = require('./events');

var _events2 = _interopRequireDefault(_events);

var _unscheduledEvents = require('./unscheduled-events');

var _unscheduledEvents2 = _interopRequireDefault(_unscheduledEvents);

var _stages = require('./stages');

var _stages2 = _interopRequireDefault(_stages);

var _one = require('./one');

var _one2 = _interopRequireDefault(_one);

var _adjudicators = require('./adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _persons = require('./persons');

var _persons2 = _interopRequireDefault(_persons);

var _groupFees = require('./groupFees');

var _groupFees2 = _interopRequireDefault(_groupFees);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _reduxImmutable.combineReducers)({
  carts: _cart2.default,
  products: _products2.default,
  events: _events2.default,
  unscheduledEvents: _unscheduledEvents2.default,
  stages: _stages2.default,
  one: _one2.default,
  adjudicators: _adjudicators2.default,
  persons: _persons2.default,
  groupFees: _groupFees2.default
});


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/index.js
// module id = 697
// module chunks = 0